module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "part",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_vm._v("The Gods")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The five great gods of the Pentatheon are—")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Visek The Supreme Parent is often regarded as male, but also as a triad: Father, Mother, and First Source. Visek may be spoken of in the singular or plural, as masculine, feminine, or abstract in ways that will not readily translate into English. The Light, the All-Knowing, the Father of Gods, etc., may take on attributes of other deities, such as wisdom, creation, justice. There are hints of monotheism in Visek worship. Except in Niol, where his main temple stands, Visek seems too remote and abstract a god to be truly popular with the masses. He is associated with the sun, fire, silver, and the color white.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("His many avatars include Chiol (destiny) and Wyseth (the sun).")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Eltiana The Lady is goddess of love, motherhood, passion, childbirth, crops, agriculture, transition. Her clergy wear red; her symbol is Ø and her main temple is at Randor. She is the only major deity to be directly identified with one of the four moons.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Her avatars include Ois, goddess of mountain passes.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Karzon The Man is the god of creation and destruction, and thus of war, strength, courage, virility, vengeance, pestilence, nature, and animal husbandry. His clergy wear green, his symbol is a hammer. His main temple is at Tharg and he is associated with the moon Trumb.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("As Zath he is god of death, and hence the most feared of the gods. Then his color is black and his symbol a skull. Other avatars include Garward (strength), Ken’th (virility), and Krak’th (earthquakes).")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Astina The Maiden is goddess of purity, duty, justice, patron of warriors and athletes. Her clergy wear blue and her symbol is a five-pointed star. Her main sanctuary is at Joal. She is associated with Ysh, the blue moon.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Her avatars include Iilah (athletes), Irepit (repentance), Ysh (constancy and duty), and Ursula (justice).")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tion The Youth is god of art, beauty, science, knowledge, healing. His clergy wear yellow. His main temple is at Suss. The unpredictable yellow moon Kirb’l is identified with his avatar the god of humor.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("His avatars include Ember’l (drama), Kirb’l (the Joker), Gunuu (courage), Yaela (singing), and Paa (healing).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91e81194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PastImperative6.vue
// module id = 87
// module chunks = 0